<template>
  <div class="networkConfiguration">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <div class="titleBox">
        <div class="title">{{ $t('localAddress') }}</div>
        <el-input style="width: 12%;margin-left: 10px" v-model="searchForm.controllerNo"></el-input>
        <!-- v-if="$auth('controllerNo_set') && controlAuth.includes('controllerNo_set')" -->
        <el-button v-if="$auth('controllerNo_set') && controlAuth.includes('controllerNo_set')" class="btn1"
                   type="primary" @click="_setControllerNo" :loading="settingControllerNo">{{ $t('set') }}
        </el-button>
      </div>
      <div class="searchBox">
        <div class="title">{{ $t('networkingMode') }}</div>
        <span class="queryInfo">{{ $t('recentQuery') }} {{ updateTime }}</span>
        <!-- v-if="$auth('network_mode_set') && controlAuth.includes('network_mode_set')"  -->
        <el-button class="btn1"
                   type="primary" @click="_setNetworkModel" :loading="setLoading">{{ $t('set') }}
        </el-button>
        <el-button class="btn2" type="primary" @click="_getNetworkModel" :loading="modelLoading">
          {{ $t('queryButton') }}
        </el-button>
        <el-form :inline="true" ref="searchForm" class="search-form">
          <el-form-item>
            <el-select :value="type" v-model="type" :placeholder="$t('selctNetworkMode')" filterable>
              <el-option :label="item.name" :value="item.code" v-for="(item, index) in network_modelTypeOptions"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="showCheckBox">
            <el-checkbox :label="$t('receiveFire')" v-model="checkBox[0]" name="type"></el-checkbox>
          </el-form-item>
          <el-form-item v-show="showCheckBox">
            <el-checkbox :label="$t('receiveLinkage')" v-model="checkBox[1]" name="type"></el-checkbox>
          </el-form-item>
          <el-form-item v-show="showCheckBox">
            <el-checkbox :label="$t('receiveFault')" v-model="checkBox[2]" name="type"></el-checkbox>
          </el-form-item>
          <el-form-item v-show="showCheckBox">
            <el-checkbox :label="$t('sendNeedRegistPanel')" v-model="checkBox[3]" name="type"></el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableBox">
        <div class="title">{{ $t('networkController') }}</div>
        <!-- v-if="$auth('network_controller') && controlAuth.includes('network_controller')" -->
        <i class="el-icon-plus addBtn" @click="addRow()"></i>
        <el-button  class="btn1"
                   type="primary" @click="_setNetworkController" :loading="settingController">{{ $t('set') }}
        </el-button>
        <el-button class="btn2" type="primary" @click="_getNetworkController()" :loading="searching">
          {{ $t('queryButton') }}
        </el-button>
        <el-table ref="basePageTable" :data="rows" :height="offsetWindowHeight" v-loading="searching"
                  :row-class-name="tableRowClassName" @cell-click="tabClick" v-clickoutside="handleClose">
          <el-table-column type="index" :label="$t('number')" :index="indexMethod" align="center"></el-table-column>
          <el-table-column prop="controllerNo" :label="$t('panelNumber')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 100px" v-model="scope.row.controllerNo" maxlength="20" size="mini"/>
              </span>
              <span v-else>{{ scope.row.controllerNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="psn" :label="$t('panelPSN')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.index === tabClickIndex">
                <el-input style="width: 100px" v-model="scope.row.psn" maxlength="20" size="mini"/>
              </span>
              <span v-else>{{ scope.row.psn }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" :label="$t('panelType')" align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.index === tabClickIndex">
                  <!-- <el-input style="width: 100px" v-model="scope.row.type" maxlength="20" size="mini"/> -->
                   <el-select :value="scope.row.type" v-model="scope.row.type" filterable>
                        <el-option :label="item.name" :value="item.code" v-for="(item, index) in controllerTypeOptions"
                         :key="index"></el-option>
                    </el-select>
                </span>
              <span v-else>{{ controllerTypeOptions.find(v=> v.code == scope.row.type).name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="descr" :label="$t('panelAnnotation')" align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 100px" v-model="scope.row.descr" maxlength="20" size="mini"/>
                  <i style="color: #2DC555;padding: 0 10px;margin-left: 10px;cursor: pointer"
                     @click.stop="onConfirm(tabClickIndex)" class="iconfont icondui" :title="$t('save')"></i>
                  <i style="color: #FB6041;padding: 0 10px;cursor: pointer" @click.stop="onCancel(tabClickIndex)"
                     class="iconfont iconcuo" :title="$t('cancel')"></i>
                  <i class="btn el-icon-delete icon-danger" style="cursor: pointer" @click.stop="remove(scope.row, tabClickIndex)"
                     :title="$t('delete')"></i>
                </span>
              <span v-else>{{ scope.row.descr }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import BasePage from "@/components/BasePage";
import {
  getNetworkModel,
  getNetworkController,
  setNetworkModel,
  setNetworkController,
  setControllerNo
} from 'api/query'
import {formatDate} from "assets/utils";
import {mapState} from 'vuex'
import Status from "components/Status";
const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数，则调用那个函数，
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  update() {},
  unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}
export default {
  name: "networkConfiguration",
  mixins: [BasePage, Status],
  components: {
    Box
  },
  /**在vue里注册构造的函数**/
  directives: { clickoutside },
  data() {
    return {
      searchForm: {
        controllerNo: ''
      },
      checkBox: [],
      style: null,
      tabClickIndex: null,
      bottomHeight: null,
      clicked: true,
      tabClickLabel: '',
      updateTime: '',
      oldControllerNotes: '',
      type: '',
      showCheckBox: true,
      modelLoading: false,
      setLoading: false,
      settingController: false,
      settingControllerNo: false
    }
  },
  computed: {
    ...mapState({
      network_modelTypeOptions: state => state.network_modelTypeOptions,
      controllerTypeOptions: state => state.controllerTypeOptions,
      network_modelOptions: state => state.network_modelOptions
    }),
    controllInfo() {
      return this.$store.state.controlInfo
    },
    controlAuth() {
      return this.$store.state.controlAuth
    },
  },
  mounted() {
    this.calcHeight()
    this.searchForm.controllerNo = this.controllInfo.controllerNo
    this.$nextTick(() => {
      document.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) {
          this.tabClickIndex = null
          this.tabClickLabel = ''
        }
      })
    })
  },
  watch: {
    network_modelOptions() {
      this._normalized()
    },
    type(newval) {
      if (newval === 2) {
        this.showCheckBox = false
      } else {
        this.showCheckBox = true
      }
    }
  },
  methods: {
    handleClose () { // 点击除了页面其他地方关闭车型选择
      this.tabClickIndex = null
      this.tabClickLabel = ''
    },
    addRow() {
      this.rows.unshift({
        psn: '',
        controllerNo: '',
        type: '',
        descr: ''
      })
    },
    _setControllerNo() {
      this.settingControllerNo = true
      this.show()
      let params = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.searchForm.controllerNo
      }
      setControllerNo(params).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
          this.settingControllerNo = false
        }
      }).catch(() => {
        this.failed()
        this.settingControllerNo = false
      })
    },
    _setNetworkController() {
      this.settingController = true
      this.show()
      let params = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllers: []
      }
      // 深拷贝：完全的拷贝一个对象，即使嵌套了对象，两者也相互分离，修改一个对象的属性，也不会影响另一个。
      /*params.controllers = JSON.parse(JSON.stringify(this.rows));*/
      this.rows.forEach((item) => {
        let obj = {}
        obj.psn = item.psn
        obj.controllerNo = item.controllerNo
        obj.type = item.type
        obj.descr = item.descr
        /*if (item.index) {
          delete item.index
        }
        if (item.time) {

        }*/
        params.controllers.push(obj)
      })
      setNetworkController(params).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
          this.settingController = false
        }
      }).catch(() => {
        this.failed()
        this.settingController = false
      })
    },
    _setNetworkModel() {
      if (this.type === "") {
        this.$message.warning("请选择组网模式")
        return
      }
      this.setLoading = true
      this.show()
      let params = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.controllInfo.controllerNo,
        type: this.type
      }
      let result = []
      for (let i = 0; i < this.checkBox.length; i++) {
        if (this.checkBox[i] === true) {
          result.push(i + 1)
        }
      }
/*      result.forEach(item => {
        item = this.network_modelOptions.find(v => v.code === item).name
      })*/
      params.model = result
      setNetworkModel(params).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
          this.setLoading = false
        }
      }).catch(() => {
        this.failed()
        this.setLoading = false
      })
    },
    _normalized() {
      let map = []
      this.network_modelOptions.forEach((item, index) => {
        map[index] = false
      })
      this.checkBox = map
    },
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    _getNetworkModel() {
      for (let i = 0; i < 4; i++) {
        this.checkBox[i] = false
      }
      this.modelLoading = true
      this.show()
      let params = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.controllInfo.controllerNo
      }
      getNetworkModel(params).then((res) => {
        this.type = res.data.type
        res.data.model.forEach(model => {
          this.checkBox[model - 1] = true
        })
        this.modelLoading = false
        this.updateTime = formatDate(new Date())
        this.success(res.message ? res.message : '操作成功')
      }).catch(() => {
        this.failed()
        this.modelLoading = false
      })
    },
    _getNetworkController() {
      this.searching = true
      this.show()
      let params = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.controllInfo.controllerNo
      }
      getNetworkController(params).then((res) => {
        // res.data.forEach((item) => {
        //   item.type = this.controllerTypeOptions.find(v => v.code === item.type).name
        // })
        this.rows = res.data
        this.searching = false
        this.success(res.message ? res.message : '操作成功')
      }).catch(() => {
        this.failed()
        this.searching = false
      })
    },
    getRows() {
    },
    tableRowClassName({row, rowIndex}) {
      // 把每一行的索引放进row
      row.index = rowIndex
    },
    onConfirm(tabClickIndex) {
      /*this.show()
      let params = {
        controllerPsn: this.controllInfo.controllerPsn
      }
      // 深拷贝：完全的拷贝一个对象，即使嵌套了对象，两者也相互分离，修改一个对象的属性，也不会影响另一个。
      params.controllers = JSON.parse(JSON.stringify(this.rows));
      /!*params.controllers.forEach((item) => {
        item.type = this.controllerTypeOptions.find(v => v.name === item.type).code
      })*!/
      setNetworkController(params).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.failed()
      })*/
      this.tabClickIndex = null
      this.tabClickLabel = ''
    },
    onCancel(tabClickIndex) {
      this.$message.info('取消编辑')
      this.tabClickIndex = null
      this.tabClickLabel = ''
    },
    remove(row, tabClickIndex) {
      this.$confirm(`确定删除改条记录吗?`).then(() => {
        this.rows.splice(tabClickIndex, 1)
        if (row.controllerNo === '') {
          this.$message.warning('数据不存在，无法删除')
        }
      })
    },
    // tabClick row 当前行 column 当前列
    tabClick(row, column, cell, event) {
      this.tabClickIndex = row.index
      this.tabClickLabel = column.label
      this.oldControllerNotes = row.controllerNotes
      switch (column.label) {
        case '控制器注释':
          this.tabClickIndex = row.index
          this.tabClickLabel = column.label
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.networkConfiguration {
  .titleBox {
    border-bottom: 1px solid #EBEEF5;

    .title {
      display: inline-block;
      font-weight: bold;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold;
      line-height: 30px;
      color: #2F4E68FF;
      margin-bottom: 10px;
    }

    .btn1, .btn2 {
      float: right;
      width: 90px;
    }

    .btn2 {
      margin-right: 20px;
    }
  }

  .searchBox {
    padding: 10px 0 10px 0;
    border-bottom: 1px solid #EBEEF5;

    .title {
      display: inline-block;
      font-weight: bold;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold;
      line-height: 30px;
      color: #2F4E68FF;
      margin-bottom: 10px;
    }

    .queryInfo {
      padding: 0 10px;
      color: #B3BBC1;
      font-size: 12px;
    }

    .btn1, .btn2 {
      float: right;
      width: 90px;
    }

    .btn2 {
      margin-right: 20px;
    }
  }

  .tableBox {
    padding: 10px 0 0 0;

    .title {
      display: inline-block;
      font-weight: bold;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold;
      line-height: 30px;
      color: #2F4E68FF;
      margin-bottom: 10px;
    }

    .addBtn {
      color: #00BEFF;
      padding: 0 10px 10px 10px;
      font-weight: bold;

      &:hover {
        cursor: pointer;
      }
    }
    .btn {
      font-size: 16px;
      padding: 0 5px;
    }

    .icon-danger {
      color: #F56C6C;
    }
    .btn1, .btn2 {
      float: right;
      width: 90px;
    }

    .btn2 {
      margin-right: 20px;
    }
  }
}
</style>
